<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<div style="padding-top: 180px;">
<p>“We are tied together in a single garment of destiny. We are caught in a network of mutuality, And I can never be who I ought to be until you are who you ought to be.”</p>
<br/>
<p style="text-align: right;">John Paul Sartre, <em>THE EXIT</em></p>
<br/>
<p>“Do we in our time have an answer to the question of what we really mean by the word ‘being’?”</p>
<br/>
<p style="text-align: right;">Martin Heidegger, <em>BEING AND TIME</em></p>
<br/>
<p>“The mission of Israel is to prepare humanity for the rule of God.”</p>
<br/>
<p style="text-align: right;">Martin Buber, <em>THE PROPHETIC FAITH</em></p>
<br/>
<p>“I came to cast fire upon the earth; and would that it were already kindled!”</p>
<br/>
<p style="text-align: right;">Jesus of Nazareth, LUKE 12:49</p>
</div>
<p><em><br/>
</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?445441be